import { lazyLoad } from 'utils/loadable';

export const EventFormPage = lazyLoad(
  () => import('./index'),
  module => module.EventFormPage,
);
